import React, {Fragment, memo, useState} from "react";
import PropTypes from "prop-types";
import {Col, Modal, ModalBody, ModalHeader, Row} from "reactstrap";
import {FaChartLine, FaClock} from "react-icons/fa";
import ZeusButton from "../../components/Button";
import {useDisclosure} from "../../hooks/useDisclosure";
import AlertForm from "./components/AlertForm";

const AddAlert = (props) => {
  const {open, onCloseHandler} = props;
  const [metricType, setMetricType] = useState();
  const {
    isOpen: isAlertFormOpen,
    onOpen: openAlertForm,
    onClose: closeAlertForm,
  } = useDisclosure();

  const handleSelection = (type) => {
    setMetricType(type);
    onCloseHandler();
    openAlertForm();
  };

  return (
    <Fragment>
      <Modal
        unmountOnClose={true}
        isOpen={open}
        backdrop={"static"}
        contentClassName="custom-small-width"
        className="custom-container"
      >
        <ModalHeader toggle={onCloseHandler}>
          <div className="modal_edit_header roboto-bold">ADD NEW ALERT</div>
        </ModalHeader>
        <ModalBody>
          <div className="pl-lg-4">
            <Row>
              <Col md="6" sm="12" xs="12" className="mobile-alert-selection">
                <ZeusButton
                  type="info-color"
                  withShadow
                  withRadius
                  largeButton
                  onClick={() => {
                    handleSelection("downtime");
                  }}
                  data-cy="select_downtime"
                >
                  <FaClock className="mr-2" />
                  DOWNTIME
                </ZeusButton>
              </Col>
              <Col md="6" sm="12" xs="12" className="mobile-alert-selection">
                <ZeusButton
                  type="info-color"
                  withRadius
                  withShadow
                  largeButton
                  onClick={() => {
                    handleSelection("metric");
                  }}
                  data-cy="select_metric"
                >
                  <FaChartLine className="mr-2" />
                  METRIC
                </ZeusButton>
              </Col>
            </Row>
          </div>
        </ModalBody>
      </Modal>
      {isAlertFormOpen && (
        <AlertForm
          closeAlertForm={closeAlertForm}
          metricType={metricType}
          showAlertForm={isAlertFormOpen}
        />
      )}
    </Fragment>
  );
};

AddAlert.propTypes = {
  open: PropTypes.bool,
  onCloseHandler: PropTypes.func,
};

export default memo(AddAlert);
